<div
  class="circle-icon"
  [ngStyle]="{
    width: size + 'px',
    height: size + 'px',
    background: backgroundColor,
    color: color,
    fontSize: size * 0.55 + 'px'
  }"
>
  <i [class]="icon"></i>
</div>
